import React, { memo } from "react";
import PropTypes from "prop-types";
import { getProductVariant } from "utilities";
import Taxonomy from "./taxonomy";
import Trend from "./trend";

const Tagging = (props) => {
  const productId = props.productId;

  const loadOtherTagInfo = (info) => {
    // setLoadTaggingInfo(info)
  };
  if (productId == "") {
    return null;
  }
  const productVariant = getProductVariant();
  if (!productVariant || productVariant == "") return null;
  return (
    <div className="gennx-content-wrapper content-wrapper" style={{ overflowY: "hidden" }}>
      {productVariant === "Insider" ? (
        <Trend {...props} loadOtherTagInfo={loadOtherTagInfo} />
      ) : (
        <Taxonomy {...props} loadOtherTagInfo={loadOtherTagInfo} />
      )}
    </div>
  );
};
Tagging.propTypes = {
  productId: PropTypes.string,
};

export default memo(Tagging);
